export type DsColor = 'accent' | 'danger' | 'success' | 'warning' | 'action' | 'brand';

/** Хроматические тона ДС для статусов и аватаров — только variant="light". */
export type ChromaticTone = 'gray' | 'violet' | 'fuchsia' | 'blue' | 'green' | 'yellow' | 'orange' | 'red';

export interface DsRole {
  palette: string;
  filled: string;
  filledHover: string;
  contrast: string;
  light: string;
  lightColor: string;
  text: string;
}

export const lightHover = (background: string) =>
  `color-mix(in srgb, ${background}, var(--color-foreground-foreground) 6%)`;

export const dsRoles: Record<DsColor, DsRole> = {
  accent: {
    palette: 'neutral',
    filled: 'var(--color-accent-default)',
    filledHover: 'var(--color-accent-hover)',
    contrast: 'var(--color-accent-foreground)',
    light: 'var(--color-accent-soft-default)',
    lightColor: 'var(--color-accent-soft-foreground)',
    text: 'var(--color-default-foreground)',
  },
  danger: {
    palette: 'ruby',
    filled: 'var(--color-danger-default)',
    filledHover: 'var(--color-danger-hover)',
    contrast: 'var(--color-danger-foreground)',
    light: 'var(--color-chromatic-red-background)',
    lightColor: 'var(--color-chromatic-red-foreground)',
    text: 'var(--color-danger-default)',
  },
  success: {
    palette: 'emerald',
    filled: 'var(--color-success-default)',
    filledHover: 'var(--color-success-hover)',
    contrast: 'var(--color-success-foreground)',
    light: 'var(--color-chromatic-green-background)',
    lightColor: 'var(--color-chromatic-green-foreground)',
    text: 'var(--color-success-default)',
  },
  warning: {
    palette: 'coral',
    filled: 'var(--color-warning-default)',
    filledHover: 'var(--color-warning-hover)',
    contrast: 'var(--color-warning-foreground)',
    light: 'var(--color-chromatic-orange-background)',
    lightColor: 'var(--color-chromatic-orange-foreground)',
    text: 'var(--color-warning-default)',
  },
  action: {
    palette: 'blue',
    filled: 'var(--color-action-default)',
    filledHover: 'var(--color-action-hover)',
    contrast: 'var(--color-action-foreground)',
    light: 'var(--color-chromatic-blue-background)',
    lightColor: 'var(--color-chromatic-blue-foreground)',
    text: 'var(--color-action-default)',
  },
  brand: {
    palette: 'brand',
    filled: 'var(--color-brand-default)',
    filledHover: 'var(--color-brand-hover)',
    contrast: 'var(--color-brand-foreground)',
    light: 'var(--color-chromatic-brand-background)',
    lightColor: 'var(--color-chromatic-brand-foreground)',
    text: 'var(--color-chromatic-brand-foreground)',
  },
};

/** Имя тона в Mantine → суффикс токенов --color-chromatic-{tone}-*. */
export const chromaticTones: Record<ChromaticTone, string> = {
  fuchsia: 'fuchsia',
  violet: 'violet',
  gray: 'grey',
  green: 'green',
  blue: 'blue',
  red: 'red',
  yellow: 'yellow',
  orange: 'orange',
};

export const isDsColor = (color: string): color is DsColor => color in dsRoles;
export const isChromaticTone = (color: string): color is ChromaticTone => color in chromaticTones;
